import React from "react";
import { cx, eyebrow } from "../lib/ui";
import Reveal from "./Reveal";

/**
 * Rule + micro-caption that opens every section.
 * Aligned to the top rather than centred, so a label that wraps to two
 * lines keeps its rule against the first line instead of drifting
 * between them.
 */
export default function SectionLabel({ children, className = "", delay = 0 }) {
  return (
    <Reveal className={cx("flex items-start gap-3.5", eyebrow, className)} delay={delay}>
      <i className="mt-[6px] block h-px w-10 flex-none bg-current opacity-40" />
      <span>{children}</span>
    </Reveal>
  );
}
